import throttle from 'lodash/throttle';
import { Values } from '@lib/interfaces/form';

export const DEFAULT_PERSIST_THROTTLE_MS = 300;

export type PersistFn = (values: Values) => void;

export function createThrottledPersist(
  persistFn: PersistFn,
  delay = DEFAULT_PERSIST_THROTTLE_MS,
) {
  const throttled = throttle(persistFn, delay, { leading: false });

  const wrapper = (values: Values) => {
    throttled(values);
  };

  wrapper.cancel = throttled.cancel;
  wrapper.flush = throttled.flush;

  return wrapper;
}
